var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg004Checklist(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "966pt",
    viewBox: "0 -15 966.25045 966",
    width: "966pt",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 77.921875 841.703125 L 483.125 841.703125 L 483.125 810.527344 L 77.921875 810.527344 C 52.101562 810.527344 31.167969 789.59375 31.167969 763.773438 L 31.167969 78.046875 C 31.167969 52.21875 52.101562 31.292969 77.921875 31.292969 L 763.648438 31.292969 C 789.480469 31.292969 810.402344 52.21875 810.402344 78.046875 L 810.402344 436.492188 L 841.578125 436.492188 L 841.578125 78.046875 C 841.527344 35.03125 806.667969 0.175781 763.648438 0.125 L 77.921875 0.125 C 34.914062 0.175781 0.0546875 35.03125 0 78.046875 L 0 763.773438 C 0.0546875 806.789062 34.914062 841.644531 77.921875 841.703125 Z M 77.921875 841.703125 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 62.34375 62.46875 L 93.507812 62.46875 L 93.507812 93.632812 L 62.34375 93.632812 Z M 62.34375 62.46875 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 124.675781 62.46875 L 155.851562 62.46875 L 155.851562 93.632812 L 124.675781 93.632812 Z M 124.675781 62.46875 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 187.015625 62.46875 L 218.1875 62.46875 L 218.1875 93.632812 L 187.015625 93.632812 Z M 187.015625 62.46875 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 62.34375 124.800781 L 779.234375 124.800781 L 779.234375 155.976562 L 62.34375 155.976562 Z M 62.34375 124.800781 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 222.753906 191.707031 L 183.167969 231.292969 C 149.707031 209.140625 104.898438 215.9375 79.503906 247.015625 C 54.113281 278.089844 56.390625 323.355469 84.765625 351.726562 C 113.136719 380.109375 158.40625 382.386719 189.484375 356.992188 C 220.558594 331.601562 227.359375 286.785156 205.203125 253.332031 L 244.785156 213.746094 Z M 140.257812 342.984375 C 114.441406 342.984375 93.507812 322.054688 93.507812 296.234375 C 93.507812 270.410156 114.441406 249.484375 140.257812 249.484375 C 147.210938 249.507812 154.050781 251.101562 160.289062 254.152344 L 129.246094 285.199219 L 151.277344 307.238281 L 182.34375 276.210938 C 185.394531 282.445312 186.992188 289.285156 187.015625 296.234375 C 187.015625 322.054688 166.089844 342.984375 140.257812 342.984375 Z M 140.257812 342.984375 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 264.941406 249.484375 L 529.875 249.484375 L 529.875 280.648438 L 264.941406 280.648438 Z M 264.941406 249.484375 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 264.941406 311.820312 L 374.03125 311.820312 L 374.03125 342.984375 L 264.941406 342.984375 Z M 264.941406 311.820312 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 405.203125 311.820312 L 623.382812 311.820312 L 623.382812 342.984375 L 405.203125 342.984375 Z M 405.203125 311.820312 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 561.046875 249.484375 L 716.894531 249.484375 L 716.894531 280.648438 L 561.046875 280.648438 Z M 561.046875 249.484375 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 222.753906 378.722656 L 183.167969 418.308594 C 149.707031 396.15625 104.898438 402.953125 79.503906 434.03125 C 54.113281 465.109375 56.390625 510.371094 84.765625 538.75 C 113.136719 567.125 158.40625 569.402344 189.484375 544.007812 C 220.558594 518.613281 227.359375 473.8125 205.203125 440.347656 L 244.785156 400.761719 Z M 140.257812 530.003906 C 114.441406 530.003906 93.507812 509.070312 93.507812 483.25 C 93.507812 457.425781 114.441406 436.492188 140.257812 436.492188 C 147.210938 436.519531 154.050781 438.117188 160.289062 441.167969 L 129.246094 472.222656 L 151.277344 494.253906 L 182.34375 463.222656 C 185.394531 469.460938 186.992188 476.300781 187.015625 483.25 C 187.015625 509.070312 166.089844 530.003906 140.257812 530.003906 Z M 140.257812 530.003906 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 264.941406 436.492188 L 529.875 436.492188 L 529.875 467.664062 L 264.941406 467.664062 Z M 264.941406 436.492188 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 264.941406 498.835938 L 374.03125 498.835938 L 374.03125 530.003906 L 264.941406 530.003906 Z M 264.941406 498.835938 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 405.203125 498.835938 L 529.875 498.835938 L 529.875 530.003906 L 405.203125 530.003906 Z M 405.203125 498.835938 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 561.046875 436.492188 L 623.382812 436.492188 L 623.382812 467.664062 L 561.046875 467.664062 Z M 561.046875 436.492188 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 222.753906 565.738281 L 183.167969 605.324219 C 149.707031 583.171875 104.898438 589.96875 79.503906 621.046875 C 54.113281 652.125 56.390625 697.386719 84.765625 725.765625 C 113.136719 754.144531 158.40625 756.414062 189.484375 731.023438 C 220.558594 705.628906 227.359375 660.824219 205.203125 627.359375 L 244.785156 587.777344 Z M 140.257812 717.019531 C 114.441406 717.019531 93.507812 696.085938 93.507812 670.265625 C 93.507812 644.441406 114.441406 623.511719 140.257812 623.511719 C 147.210938 623.535156 154.050781 625.128906 160.289062 628.183594 L 129.246094 659.238281 L 151.277344 681.269531 L 182.34375 650.238281 C 185.394531 656.476562 186.992188 663.320312 187.015625 670.265625 C 187.015625 696.085938 166.089844 717.019531 140.257812 717.019531 Z M 140.257812 717.019531 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 264.941406 623.511719 L 467.539062 623.511719 L 467.539062 654.6875 L 264.941406 654.6875 Z M 264.941406 623.511719 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 264.941406 685.851562 L 374.03125 685.851562 L 374.03125 717.019531 L 264.941406 717.019531 Z M 264.941406 685.851562 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 405.203125 685.851562 L 467.539062 685.851562 L 467.539062 717.019531 L 405.203125 717.019531 Z M 405.203125 685.851562 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 732.484375 935.210938 C 861.597656 935.210938 966.25 830.539062 966.25 701.4375 C 966.25 572.324219 861.597656 467.664062 732.484375 467.664062 C 603.371094 467.664062 498.710938 572.324219 498.710938 701.4375 C 498.863281 830.480469 603.433594 935.054688 732.484375 935.210938 Z M 732.484375 498.835938 C 844.371094 498.835938 935.085938 589.542969 935.085938 701.4375 C 935.085938 813.332031 844.371094 904.035156 732.484375 904.035156 C 620.585938 904.035156 529.875 813.332031 529.875 701.4375 C 530.007812 589.597656 620.636719 498.960938 732.484375 498.835938 Z M 732.484375 498.835938 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 637.417969 710.050781 L 609.519531 723.980469 L 640.691406 786.320312 C 642.925781 790.804688 647.191406 793.941406 652.140625 794.742188 C 652.945312 794.867188 653.75 794.933594 654.558594 794.945312 C 658.6875 794.945312 662.652344 793.300781 665.582031 790.378906 L 852.589844 603.363281 L 830.558594 581.324219 L 658.824219 753.050781 Z M 637.417969 710.050781 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg004Checklist);
export default __webpack_public_path__ + "static/media/004-checklist.71ebdd05bdb55b3fdf1fd0f0ae88e3bd.svg";
export { ForwardRef as ReactComponent };